export const FORM_ERRORS = {
  ru: {
    required: 'Обязательное поле',
    password: {
      invalid:
        'Пароль должен включать не менее 6 и не более 30 символов, содержать только латинские буквы, цифры и специальные символы.',
    },
    email: {
      max: 'Поле ${label} должно быть не более ${max} символов',
    },
    string: {
      range: 'Поле должно содержать не менее ${min} и не более ${max} символов',
      max: 'Поле ${label} должно быть не более ${max} символов',
    },
    number: {
      range: "Поле ${label} должно быть между ${min} и ${max}",
    },
    types: {
      email: 'Неверный формат почты',
    },
  },
  en: {
    required: 'Required field',
    password: {
      invalid:
        'The password must include at least 6 and no more than 30 characters, contain only Latin letters, numbers and special characters.',
    },
    email: {
      max: 'The ${label} field must be no more than ${max} characters',
    },
    string: {
      range: 'The field must contain at least ${min} and no more than ${max} characters',
      max: 'The ${label} field must be no more than ${max} characters',
    },
    number: {
      range: "${name} must be between ${min} and ${max}",
    },
    types: {
      email: 'Invalid email format',
    },
  },
  es: {
    required: 'Campo requerido',
    password: {
      invalid:
        'La contraseña debe incluir al menos 6 y no más de 30 caracteres, contener solo letras latinas, números y caracteres especiales.',
    },
    email: {
      max: 'El campo ${label} no debe tener más de ${max} caracteres',
    },
    string: {
      range: 'El campo debe contener al menos ${min} y no más de ${max} caracteres',
      max: 'El campo ${label} no debe tener más de ${max} caracteres',
    },
    number: {
      range: "${name} debe estar entre ${min} y ${max}",
    },
    types: {
      email: 'Formato de correo no válido',
    },
  },
  zh: {
    required: '必填项',
    password: {
      invalid:
        '密码必须包含6到30个字符，只能包含拉丁字母、数字和特殊字符。',
    },
    email: {
      max: '${label} 不能超过 ${max} 个字符',
    },
    string: {
      range: '该字段必须包含至少 ${min} 个且不超过 ${max} 个字符',
      max: '${label} 不能超过 ${max} 个字符',
    },
    number: {
      range: '${name} 必须在 ${min} 和 ${max} 之间',
    },
    types: {
      email: '邮箱格式无效',
    },
  },
};

export const ROLE_ERRORS = {
  roleName: [
    {
      regexp: /value.not.unique/,
      message: 'administration.role_form_name_already_existed',
    },
  ],
};

export const ADMIN_ERRORS = {
  email: [
    {
      regexp: /value.not.unique/,
      message: 'administration.admin_form_email_already_existed',
    },
  ],
};

export const DELETE_ROLE_ERRORS = {
  'error.cannot-delete-role': 'administration.role_delete_failed',
};

export const NEWS_ERRORS = {
  text: [
    {
      regexp: /value.too.short/,
      message: 'news.news_form_text_too_short',
    },
  ],
};

export const LANGUAGE_ERRORS = {
  name: [
    {
      regexp: /value.not.unique/,
      message: 'languages.language_form_name_already_existed',
    },
    {
      regexp: /value.too.short/,
      message: 'common.value_too_short',
    },
    {
      regexp: /value.not.allowed/,
      message: 'common.value_not_allowed',
    },
  ],
  code2: [
    {
      regexp: /value.not.unique/,
      message: 'languages.language_form_code2_already_existed',
    },
    {
      regexp: /value.too.short/,
      message: 'common.value_too_short',
    },
    {
      regexp: /value.not.allowed/,
      message: 'common.value_not_allowed',
    },
  ],
  code3: [
    {
      regexp: /value.not.unique/,
      message: 'languages.language_form_code3_already_existed',
    },
    {
      regexp: /value.too.short/,
      message: 'common.value_too_short',
    },
    {
      regexp: /value.not.allowed/,
      message: 'common.value_not_allowed',
    },
  ],
};

export const USER_ERRORS = {
  email: [
    {
      regexp: /value.not.unique/,
      message: 'administration.admin_form_email_already_existed',
    },
  ],
  name: [
    {
      regexp: /value.not.unique/,
      message: 'administration.admin_form_email_already_existed',
    },
  ],
  phoneNumber: [
    {
      regexp: /value.not.unique/,
      message: 'users.user_form_phone_already_existed',
    },
  ],
};

export const RADAR_ERRORS = {
  value: [
    {
      regexp: /value.not.unique/,
      message: 'radar.table_error_value_not_unique',
    },
  ],
};

export const KEYWORDS_ERRORS = {
  keyword: [
    {
      regexp: /value.not.unique/,
      message: 'moderation.keyword_form_existed',
    },
  ],
};

export const PACKAGES_ERRORS = {
  name: [
    {
      regexp: /error.name.not_unique.name/,
      message: 'packages.form.name_not_unique',
    },
  ],
  price: [
    {
      regexp: /error.price.not_unique.price/,
      message: 'packages.form.price_not_unique',
    },
  ],
  productId: [
    {
      regexp: /error.productId.not_unique.productId/,
      message: 'packages.form.name_not_unique',
    },
  ]
}

export const GIFTS_CATEGORIES_ERROR = {
  'error.category.has_gifts': 'error.category.has_gifts'
}

export const PACKAGE_ERROR = {
  'error.package.used_in_market_service_price': 'error.package.used_in_market_service_price',
  'error.package.used_in_gift': 'error.package.used_in_gift',
}

export const JJ_COINS_ERRORS = {};
export const JJ_LIKES_ERRORS = {
  value: [
    {
      regexp: /value.not.unique/,
      message: 'jj_likes.form.value.not_unique',
    }
  ]
};
export const JJ_PREMIUM_ERRORS = {};
export const JJ_FUN_ERRORS = {};
export const JJ_VIDEO_ERRORS = {};
export const JJ_FORTUNE_ERRORS = {};

export const EXPIRED_TOKEN_MESSAGE = 'Expired JWT Token';
export const INVALID_TOKEN_MESSAGE = 'Invalid JWT Token';
